import { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
import Avatar from './Avatar';
import ImageUploader from './ImageUploader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages } from '@fortawesome/free-solid-svg-icons';

const AVATAR_UPLOAD_SIZE = 100;

const styles = css`
position: relative;
display: flex;
flex-direction: column;
gap: 30px;
height: ${AVATAR_UPLOAD_SIZE}px;
width: ${AVATAR_UPLOAD_SIZE}px;
border-radius: 50%;
border: 1px solid black;
justify-content: center;
align-items: center;

  & .avatar {
    position: absolute;
    width: 100%;
    height: 100%;
    &.hidden {
      display: none
    }
  }
  & .photo-icon {
    color: #057bff;
    border-radius: 10px;
    background-color: white;
    font-size: 2em;
    position: absolute;
    bottom: -10px;
    right: -10px;

  }
`;

const AvatarUpload = styled(({ className, onUploaded, avatar }) => {
  const [avatarIsUploading, setAvatarIsUploading] = useState(false);
  const [newAvatar, setNewAvatar] = useState(avatar);
  const [, setError] = useState(null);
  useEffect(() => {
    window.addEventListener('message', handleIframeMessage, false)
    return () => {
      window.removeEventListener('message', handleIframeMessage)
    }
  });

  const handleIframeMessage = (e) => {
    if (e.data.event === 'fileUploadStarted') return setAvatarIsUploading(true);
  }

  const onAvatarUploaded = async file => {
    const { attributes: { 'cdn-url': cdn_url } } = file;
    setNewAvatar(cdn_url);
    setAvatarIsUploading(false);
    onUploaded(cdn_url);
  }

  return (
    <div className={className}>
      <ImageUploader text='' onUploading={setAvatarIsUploading} onSuccess={onAvatarUploaded} onError={setError}>
        <div className={`avatar ${avatarIsUploading ? 'hidden' : ''}`}>
          <Avatar width={AVATAR_UPLOAD_SIZE} src={newAvatar ? newAvatar : null} />
        </div>
        <div className='photo-icon'>
          <FontAwesomeIcon icon={faImages} />
        </div>
      </ImageUploader>

    </div>
  )
})`${styles}`;

export default AvatarUpload;